import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_COST_BREAKDOWNS_REQUEST = 'GET_COST_BREAKDOWNS_REQUEST';
export const GET_COST_BREAKDOWNS_SUCCESS = 'GET_COST_BREAKDOWNS_SUCCESS';
export const GET_COST_BREAKDOWNS_ERROR = 'GET_COST_BREAKDOWNS_ERROR';

export const GET_COST_BREAKDOWN_REQUEST = 'GET_COST_BREAKDOWN_REQUEST';
export const GET_COST_BREAKDOWN_SUCCESS = 'GET_COST_BREAKDOWN_SUCCESS';
export const GET_COST_BREAKDOWN_ERROR = 'GET_COST_BREAKDOWN_ERROR';

export const CREATE_COST_BREAKDOWN_REQUEST = 'CREATE_COST_BREAKDOWN_REQUEST';
export const CREATE_COST_BREAKDOWN_SUCCESS = 'CREATE_COST_BREAKDOWN_SUCCESS';
export const CREATE_COST_BREAKDOWN_ERROR = 'CREATE_COST_BREAKDOWN_ERROR';

export const UPDATE_COST_BREAKDOWN_REQUEST = 'UPDATE_COST_BREAKDOWN_REQUEST';
export const UPDATE_COST_BREAKDOWN_SUCCESS = 'UPDATE_COST_BREAKDOWN_SUCCESS';
export const UPDATE_COST_BREAKDOWN_ERROR = 'UPDATE_COST_BREAKDOWN_ERROR';

export const UPLOAD_COST_BREAKDOWN_FILES_REQUEST = 'UPLOAD_COST_BREAKDOWN_FILES_REQUEST';
export const UPLOAD_COST_BREAKDOWN_FILES_PROGRESS = 'UPLOAD_COST_BREAKDOWN_FILES_PROGRESS';
export const UPLOAD_COST_BREAKDOWN_FILES_SUCCESS = 'UPLOAD_COST_BREAKDOWN_FILES_SUCCESS';
export const UPLOAD_COST_BREAKDOWN_FILES_ERROR = 'UPLOAD_COST_BREAKDOWN_FILES_ERROR';

export const DELETE_COST_BREAKDOWN_FILE_REQUEST = 'DELETE_COST_BREAKDOWN_FILE_REQUEST';
export const DELETE_COST_BREAKDOWN_FILE_SUCCESS = 'DELETE_COST_BREAKDOWN_FILE_SUCCESS';
export const DELETE_COST_BREAKDOWN_FILE_ERROR = 'DELETE_COST_BREAKDOWN_FILE_ERROR';

export const DELETE_COST_BREAKDOWN_REQUEST = 'DELETE_COST_BREAKDOWN_REQUEST';
export const DELETE_COST_BREAKDOWN_SUCCESS = 'DELETE_COST_BREAKDOWN_SUCCESS';
export const DELETE_COST_BREAKDOWN_ERROR = 'DELETE_COST_BREAKDOWN_ERROR';

export const CLEAN_COST_BREAKDOWNS = 'CLEAN_COST_BREAKDOWNS';

// Get costBreakdowns
export function getCostBreakdowns(query) {
    return async (dispatch) => {
        try {
            dispatch(getCostBreakdownsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/cost-breakdowns/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getCostBreakdownsSuccess, getCostBreakdownsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getCostBreakdownsError));
        }
    };
}
function getCostBreakdownsRequest() {
    return {
        type: GET_COST_BREAKDOWNS_REQUEST,
        isFetching: true
    };
}
function getCostBreakdownsSuccess (payload) {
    return {
        type: GET_COST_BREAKDOWNS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getCostBreakdownsError(errorMessage) {
    return {
        type: GET_COST_BREAKDOWNS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get costBreakdown
export function getCostBreakdown(costBreakdownId) {

    return async (dispatch) => {
        try {
            dispatch(getCostBreakdownRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/cost-breakdowns/${costBreakdownId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getCostBreakdownSuccess, getCostBreakdownError));
        } catch (err) {
            dispatch(utilsLib.response(err, getCostBreakdownError));
        }
    };
}
function getCostBreakdownRequest() {
    return {
        type: GET_COST_BREAKDOWN_REQUEST,
        isFetching: true
    };
}
function getCostBreakdownSuccess (payload) {
    return {
        type: GET_COST_BREAKDOWN_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getCostBreakdownError(errorMessage) {
    return {
        type: GET_COST_BREAKDOWN_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create costBreakdown
export function createCostBreakdown(costBreakdown, options) {
    return async (dispatch) => {
        try {
            dispatch(createCostBreakdownRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/cost-breakdowns', {costBreakdown, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createCostBreakdownSuccess, createCostBreakdownError));
        } catch (err) {
            dispatch(utilsLib.response(err, createCostBreakdownError));
        }
    };
}
function createCostBreakdownRequest() {
    return {
        type: CREATE_COST_BREAKDOWN_REQUEST,
        isFetching: true
    };
}
function createCostBreakdownSuccess (payload) {
    return dispatch => {
        // Create notification for create costBreakdown success
        dispatch(addNotification({
            message: 'Escandallo añadido correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_COST_BREAKDOWN_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createCostBreakdownError(errorMessage) {
    return dispatch => {
        // Create notification for create costBreakdown error
        dispatch(addNotification({
            message: 'Error al añadir el escandallo',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_COST_BREAKDOWN_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update costBreakdown
export function updateCostBreakdown(costBreakdownId, costBreakdown = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateCostBreakdownRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/cost-breakdowns/${costBreakdownId}`, costBreakdown, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateCostBreakdownSuccess, updateCostBreakdownError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateCostBreakdownError));
        }
    };
}
function updateCostBreakdownRequest() {
    return {
        type: UPDATE_COST_BREAKDOWN_REQUEST,
        isFetching: true
    };
}
function updateCostBreakdownSuccess (payload) {
    return dispatch => {
        // Create notification for update costBreakdown success
        dispatch(addNotification({
            message: 'Escandallo actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_COST_BREAKDOWN_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateCostBreakdownError(errorMessage) {
    return dispatch => {
        // Create notification for update costBreakdown error
        dispatch(addNotification({
            message: 'Error al actualizar el escandallo',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_COST_BREAKDOWN_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload costBreakdown files
export function uploadCostBreakdownFiles(costBreakdownId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadCostBreakdownFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/cost-breakdowns/${costBreakdownId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadCostBreakdownFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadCostBreakdownFilesSuccess, uploadCostBreakdownFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadCostBreakdownFilesError));
        }
    };
}
function uploadCostBreakdownFilesRequest() {
    return {
        type: UPLOAD_COST_BREAKDOWN_FILES_REQUEST,
        isFetching: true
    };
}
function uploadCostBreakdownFilesProgress(percent) {
    return {
        type: UPLOAD_COST_BREAKDOWN_FILES_PROGRESS,
        percent
    };
}
function uploadCostBreakdownFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload costBreakdown file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_COST_BREAKDOWN_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadCostBreakdownFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload costBreakdown file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_COST_BREAKDOWN_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download costBreakdown file
export function downloadCostBreakdownFile(costBreakdownId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/cost-breakdowns/${costBreakdownId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete costBreakdown file
export function deleteCostBreakdownFile(costBreakdownId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteCostBreakdownFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/cost-breakdowns/${costBreakdownId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteCostBreakdownFileSuccess, deleteCostBreakdownFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteCostBreakdownFileError));
        }
    };
}
function deleteCostBreakdownFileRequest() {
    return {
        type: DELETE_COST_BREAKDOWN_FILE_REQUEST,
        isFetching: true
    };
}
function deleteCostBreakdownFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_COST_BREAKDOWN_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteCostBreakdownFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_COST_BREAKDOWN_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete costBreakdown
export function deleteCostBreakdown(costBreakdownId) {

    return async (dispatch) => {
        try {
            dispatch(deleteCostBreakdownRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/cost-breakdowns/${costBreakdownId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteCostBreakdownSuccess, deleteCostBreakdownError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteCostBreakdownError));
        }
    };
}
function deleteCostBreakdownRequest() {
    return {
        type: DELETE_COST_BREAKDOWN_REQUEST,
        isFetching: true
    };
}
function deleteCostBreakdownSuccess (payload) {
    return dispatch => {
        // Create notification for delete costBreakdown success
        dispatch(addNotification({
            message: 'Escandallo eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_COST_BREAKDOWN_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteCostBreakdownError(errorMessage) {
    return dispatch => {
        // Create notification for delete costBreakdown error
        dispatch(addNotification({
            message: 'Error al eliminar el escandallo',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_COST_BREAKDOWN_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean costBreakdowns reducer
export function cleanCostBreakdowns() {
    return {
        type: 'CLEAN_COST_BREAKDOWNS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/cost-breakdowns.js